import { render, staticRenderFns } from "./TaxRNumInfo.vue?vue&type=template&id=773467df&scoped=true&lang=pug&"
import script from "./TaxRNumInfo.vue?vue&type=script&lang=ts&"
export * from "./TaxRNumInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TaxRNumInfo.vue?vue&type=style&index=0&id=773467df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773467df",
  null
  
)

export default component.exports